import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import {
  AccountMetricInsightsMetricType,
  MetricValueType,
} from '../../../../interface/dtos';

export interface ChallengeSelfReportEntityProps {
  value: number;
  count: number;
  userId?: string;
  date?: string;
  type?: MetricValueType;
}

export class ChallengeSelfReportEntity extends Entity<ChallengeSelfReportEntityProps> {
  protected _id: string;
  static create(
    props: ChallengeSelfReportEntityProps,
    entityId?: string
  ): ChallengeSelfReportEntity {
    const id = entityId || v4();
    const entity = new ChallengeSelfReportEntity({
      id,
      props,
    });
    return entity;
  }
  public validate() {}
  get metricType() {
    return AccountMetricInsightsMetricType.SelfReport;
  }

  get count() {
    return this.props.count;
  }
  get value() {
    return this.props.value;
  }
  get userId() {
    return this.props.userId;
  }
  get avg() {
    return this.count !== 0 ? this.value / this.count : 0;
  }
  get date() {
    return this.props.date ? new Date(this.props.date) : undefined;
  }
  get type(): MetricValueType {
    return this.props.type;
  }
  setType(type: MetricValueType): MetricValueType {
    this.props.type = type;
    return this.props.type;
  }
}
